/**
 * Labstep
 *
 * @module components/File/Lightbox
 * @desc Lightbox display for a file thumbnail
 */

import { FileActionDownloadContainer as FileActionDownload } from 'labstep-web/components/File/Action/Download';
import { FileGetURLContainer } from 'labstep-web/containers/File/GetURL';
import { ThumbnailContainer } from 'labstep-web/containers/File/Thumbnail';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import type { FileLightboxProps } from './types';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

export const FileLightbox: React.FC<FileLightboxProps> = ({
  file,
  toggle,
  onError,
}) => {
  // For GIFs, use the original file URL to preserve animation
  if (file.isGif) {
    return (
      <FileGetURLContainer file={file}>
        {({ url }) => (
          <Lightbox
            plugins={[Captions, Fullscreen, Thumbnails, Zoom]}
            open
            slides={[{ src: url, title: file.name }]}
            close={toggle}
            render={{
              buttonPrev: () => false,
              buttonNext: () => false,
            }}
            toolbar={{
              buttons: [
                'close',
                <FileActionDownload key={1} unstyled file={file}>
                  <Icon
                    name="download"
                    color="white"
                    size="large"
                    style={{ marginTop: 15 }}
                  />
                </FileActionDownload>,
              ],
            }}
          />
        )}
      </FileGetURLContainer>
    );
  }

  // For other images, use the thumbnail system
  return (
    <ThumbnailContainer
      file={file.image_annotation ? file.image_annotation : file}
    >
      {({ src }) => (
        <Lightbox
          plugins={[Captions, Fullscreen, Thumbnails, Zoom]}
          open
          slides={[{ src, title: file.name }]}
          close={toggle}
          render={{
            buttonPrev: () => false,
            buttonNext: () => false,
          }}
          toolbar={{
            buttons: [
              'close',
              <FileActionDownload key={1} unstyled file={file}>
                <Icon
                  name="download"
                  color="white"
                  size="large"
                  style={{ marginTop: 15 }}
                />
              </FileActionDownload>,
            ],
          }}
        />
      )}
    </ThumbnailContainer>
  );
};
